import { DeferredPromise } from '../../utils'

export default class BetRequestBinder {
  constructor () {
    this.deferedRequestIds = {}
  }

  resolveBetslipIdByRequestId (placeBetRequestId) {
    const placeBetDeferredPromise = this.deferedRequestIds[placeBetRequestId]

    // Creating timeout promise that will race betslip id resolve
    // Need to cleaning old place bet request ids
    const resolveBetslipTimeout = new Promise(
      (resolve, reject) => {
        setTimeout(
          // Rejecting promise with error
          () => reject(new Error('timeout expired')),
          // Waiting 10 seconds to unbind
          10000
        )
      }
    )

    if (!placeBetDeferredPromise) {
      // Creating defer for start waiting and storing it
      this.deferedRequestIds[placeBetRequestId] = new DeferredPromise()

      return Promise.race([
        this.deferedRequestIds[placeBetRequestId],
        resolveBetslipTimeout
      ])
    }

    // Already waiting
    // Returning same defer by request id
    return Promise.race([
      placeBetDeferredPromise,
      resolveBetslipTimeout
    ])
  }

  bindRequestIdWithBetslip (placeBetRequestId, betslipId) {
    const placeBetDeferredPromise = this.deferedRequestIds[placeBetRequestId]

    // If place bet already waiting
    if (placeBetDeferredPromise) {
      // Resolving with provided betslip id
      placeBetDeferredPromise.resolve(betslipId)
      return placeBetDeferredPromise
    }

    // Or creating new defered promise
    const deferredPromise = new DeferredPromise()
    // And resolving it with provided betslip id
    deferredPromise.resolve(betslipId)
    // Storing new created promise
    this.deferedRequestIds[placeBetRequestId] = deferredPromise

    return deferredPromise
  }

  unbindRequestId (placeBetRequestId) {
    delete this.deferedRequestIds[placeBetRequestId]
  }
}
